<template>
  <div>
    <router-link :to="{name: 'shipping', params: {'id': shipping.id}}" class="preview-link">
      <shipping-list-item :shipping="shipping" :shipping-types="shippingTypes" :isPreview="true" />
    </router-link>
  </div>
</template>
<script>
import ShippingListItem from '@/components/ShippingListItem'

export default {
  name: 'ShippingPreview',
  props: {
    shipping: {
      type: Object,
      required: true
    },
    shippingTypes: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ShippingListItem
  }
}
</script>
